import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ExitIntent from "@/components/ExitIntent";
import Seo from "@/components/Seo";
import { isCompanyPath } from "@/lib/offers";
import { metaForPath } from "@/lib/seo";
import { scrollToId } from "@/lib/scroll";
import "@/App.css";

export default function SiteLayout() {
    const location = useLocation();
    const isCompany = isCompanyPath(location.pathname);
    const meta = metaForPath(location.pathname);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    useEffect(() => {
        if (!location.hash) return;
        const timer = window.setTimeout(() => scrollToId(location.hash), 120);
        return () => window.clearTimeout(timer);
    }, [location.pathname, location.hash]);

    return (
        <div className={isCompany ? "App home-light" : "App grain"}>
            <Seo {...meta} />
            <Navbar />
            <Outlet />
            <Footer />
            <ExitIntent />
        </div>
    );
}
